import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=27f99db1&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f99db1",
  null
  
)

export default component.exports